export const iconFontAwesomeMoneyScaleBalanced = (
	<i className="fa-solid fa-scale-balanced"></i>
);
